import { render, staticRenderFns } from "./ProgramInquiryDialog.vue?vue&type=template&id=10a56d6d"
import script from "./ProgramInquiryDialog.vue?vue&type=script&lang=js"
export * from "./ProgramInquiryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports